import React, { Component } from "react";
import ReactHtmlParser from 'react-html-parser';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import { accentCharacterCleaner, trimContent } from '../../helpers/misc-javascript-helpers.js';
import './read-more-button.css';


class Ellipsis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            styles: {
                paddingBottom: '22px',
                lineHeight: '1.25em',
                fontWeight: '300',
                courseId: '',
                suiteId: '',
                productDescription: ''
            },
            active: false
        };

        this.toggle = this._toggle.bind(this);
    }

    componentDidMount() {
        if (this.props.contentData) {
            let trimmed;
            const descriptionVar = this.props.contentData.data.data.data;
            if (typeof (descriptionVar) !== 'undefined' && descriptionVar.short_description) {
                trimmed = trimContent(accentCharacterCleaner(descriptionVar.short_description));
            }

            if (typeof (descriptionVar) !== 'undefined' && descriptionVar.plain_description) {
                trimmed = trimContent(accentCharacterCleaner(descriptionVar.plain_description));
            }
            this.setState({ productDescription: trimmed });
        }
    }
    

    _toggle() {
        this.setState({ collapse: !this.state.collapse, active: !this.state.active });
    }

    render() {
        return (
            <div className={'content'} >

                {this.state.productDescription ? <div className={(this.state.active) ? 'course-description__readmore__dropdown active' : 'course-description__readmore__dropdown'} onClick={this.toggle}>
                    {!this.state.collapse ? <HTMLEllipsis
                        unsafeHTML={this.state.productDescription}
                        maxLine={this.props.maxLine}
                        ellipsis='...'
                        basedOn='words'
                    /> : ReactHtmlParser(this.state.productDescription)}</div> : ''}
                <br />

                {this.state.productDescription ? <button onClick={this.toggle} className="course-description__readmore__button read-more-btn text-bold" tabIndex="0" aria-label={!this.state.collapse ? 'Previous text is collapsed' : 'Previous text is expanded'} aria-expanded={!this.state.collapse ? 'false' : 'true'}>{!this.state.collapse ? 'Read More' : 'Read Less'}</button> : ''}

            </div>

        );
    };

} export default Ellipsis;